/**
 * @desc 国际化
 */
export type LocaleTypes = 'us' | 'ca' | 'sa' | 'za' | 'au';
type ResType<T> = {
    readonly [P in LocaleTypes]?: T;
};

/**
 * @desc Delta pro 全屋家电产品列表
 * @param name 词条 key
 * @param img 图片路径
 * @param link 跳转外链
 */
type ProductLisType = {
    readonly name: string;
    readonly img: string[];
    readonly link: string;
};
const usProductList: ProductLisType[] = [
    {
        name: 'secN_product1',
        img: ['DELTA_Pro.webp', 'DELTA_Pro.png'],
        link: 'https://us.ecoflow.com/products/delta-pro-portable-power-station',
    },
    {
        name: 'secN_product2',
        img: ['Smart_Home_Panel.webp', 'Smart_Home_Panel.png'],
        link: 'https://us.ecoflow.com/products/smart-home-panel?variant=39777628323913',
    },
    {
        name: 'secN_product3',
        img: ['Double_Voltage_Hub.webp', 'Double_Voltage_Hub.png'],
        link: 'https://us.ecoflow.com/products/double-voltage-hub-ecoflow-delta-pro',
    },
    {
        name: 'secN_product4',
        img: ['X-Stream_Adapter.webp', 'X-Stream_Adapter.png'],
        link: 'https://us.ecoflow.com/products/ev-x-stream-adapter-delta-pro',
    },
    {
        name: 'secN_product5',
        img: ['Portable_Power_Adapter.webp', 'Portable_Power_Adapter.png'],
        link: 'https://us.ecoflow.com/products/portable-power-station-grounding-adapter',
    },
    {
        name: 'secN_product6',
        img: ['Remote_Control.webp', 'Remote_Control.png'],
        link: 'https://us.ecoflow.com/products/delta-pro-remote-control',
    },
];
const caProductList: ProductLisType[] = [
    {
        name: 'secN_product9',
        img: ['AC.png', 'AC.png'],
        link: 'https://ca.ecoflow.com/products/ac-generator-charging-adapter',
    },
    {
        name: 'secN_product10',
        img: ['50AmpHub.png', '50AmpHub.png'],
        link: 'https://ca.ecoflow.com/products/50-amp-hub',
    },

    {
        name: 'EcoFlow EV X-Stream Adapter (DELTA Pro Ultra)',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100196870/EV%20X-Stream%20Adapter%20(DELTA%20Pro%20Ultra).png'],
        link: 'https://us.ecoflow.com/products/ev-x-stream-adapter-delta-pro-ultra?variant=40758561964105',
    },
    {
        name: 'EcoFlow Double Voltage Hub (DELTA Pro)',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100529677/Double%20Voltage%20Hub(DELTA%20Pro).png'],
        link: 'https://us.ecoflow.com/products/double-voltage-hub-ecoflow-delta-pro?variant=39428708008009',
    },
    {
        name: 'EcoFlow EV X-Stream Adapter (DELTA Pro)',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100496621/EV%20X-Stream%20Adapter%20(DELTA%20Pro).png'],
        link: 'https://us.ecoflow.com/products/ev-x-stream-adapter-delta-pro?variant=39366327599177',
    },
    {
        name: 'EcoFlow Power Input/Output Cable',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100393156/power-input.png'],
        link: 'https://us.ecoflow.com/products/power-input-output-cable?variant=40767971557449',
    },
    {
        name: 'secN_product5',
        img: ['Portable_Power_Adapter.webp', 'Portable_Power_Adapter.png'],
        link: 'https://ca.ecoflow.com/products/portable-power-station-grounding-adapter',
    },
    {
        name: 'EcoFlow Smart Generator Adapter',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100583494/image%205154398.png'],
        link: 'https://us.ecoflow.com/products/delta-pro-to-smart-generator-adapter?variant=39704596152393',
    },
    {
        name: 'EcoFlow Trolley (DELTA Pro Ultra)',
        img: ['https://websiteoss.ecoflow.com/upload/image/1744100601316/Trolley%20(DELTA%20Pro%20Ultra).png'],
        link: 'https://us.ecoflow.com/products/trolley-delta-pro-ultra',
    },
    // {
    //     name: 'secN_product6',
    //     img: ['Remote_Control.webp', 'Remote_Control.png'],
    //     link: 'https://ca.ecoflow.com/products/delta-pro-remote-control',
    // },
];
const mearProductList: ProductLisType[] = [
    {
        name: 'secN_product1',
        img: ['DELTA_Pro.webp', 'DELTA_Pro.png'],
        link: `https://sa.ecoflow.com/collections/portable-power-stations`,
    },
    {
        name: 'secN_product2',
        img: ['Smart_Home_Panel.webp', 'Smart_Home_Panel.png'],
        link: '',
    },
    {
        name: 'secN_product6',
        img: ['Remote_Control.webp', 'Remote_Control.png'],
        link: 'https://www.amazon.ae/dp/B0BXDZWB5N?ref=myi_title_dp',
    },
];
const zaProductList: ProductLisType[] = [
    {
        name: 'secN_product1',
        img: ['DELTA_Pro.webp', 'DELTA_Pro.png'],
        link: `https://za.ecoflow.com/collections/portable-power-stations`,
    },
    {
        name: 'secN_product2',
        img: ['Smart_Home_Panel.webp', 'Smart_Home_Panel.png'],
        link: 'https://za.ecoflow.com/products/smart-home-panel',
    },
    {
        name: 'secN_product3',
        img: ['solar_extension_cable.webp', 'solar_extension_cable.png'],
        link: 'https://za.ecoflow.com/products/solar-extension-cable',
    },
    {
        name: 'secN_product4',
        img: ['X-Stream_Adapter.webp', 'X-Stream_Adapter.png'],
        link: 'https://za.ecoflow.com/products/solar-parallel-connection-cable',
    },
    {
        name: 'secN_product5',
        img: ['Remote_Control.webp', 'Remote_Control.png'],
        link: 'https://za.ecoflow.com/products/delta-pro-remote-control',
    },
];
const auProductList: ProductLisType[] = [
    {
        name: 'secN_product1',
        img: ['DELTA_Pro.webp', 'DELTA_Pro.png'],
        link: `https://au.ecoflow.com/collections/portable-power-stations`,
    },
    {
        name: 'secN_product2',
        img: ['TS.webp', 'TS.png'],
        link: 'https://au.ecoflow.com/products/transfer-switch',
    },
    {
        name: 'secN_product3',
        img: ['X-Stream_Adapter.webp', 'X-Stream_Adapter.png'],
        link: 'https://au.ecoflow.com/collections/accessories/products/ev-x-stream-adapter-ecoflow-delta-pro',
    },
    {
        name: 'secN_product4',
        img: ['Portable_Power_Adapter.webp', 'Portable_Power_Adapter.png'],
        link: 'https://au.ecoflow.com/collections/accessories/products/ecoflow-portable-power-station-grounding-adapter',
    },
    {
        name: 'secN_product5',
        img: ['Remote_Control.webp', 'Remote_Control.png'],
        link: 'https://au.ecoflow.com/products/delta-pro-remote-control',
    },
];
export const productMap: ResType<ProductLisType[]> = {
    us: usProductList,
    ca: caProductList,
    sa: mearProductList,
    za: zaProductList,
    au: auProductList,
} as const;

/**
 * @desc Ecoflow 用户诉说视频列表
 * @param source 视频地址
 * @param desc 描述
 */
type UserVideosType = {
    readonly source: string;
    readonly desc: string;
    readonly poster: string[];
};
const usVideoList: UserVideosType[] = [
    {
        source: 'https://www.youtube.com/embed/Uat1fPVoR4w',
        desc: 'secO_video1',
        poster: ['/img/landingPage/poster1.jpg', '/img/landingPage/poster1.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/bXd-aP06lug',
        desc: 'secO_video2',
        poster: ['/img/landingPage/poster2.jpg', '/img/landingPage/poster2.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/ddI0e46Dbb0',
        desc: 'secO_video3',
        poster: ['/img/landingPage/poster3.jpg', '/img/landingPage/poster3.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/yNBXE3BszEM',
        desc: 'secO_video4',
        poster: ['/img/landingPage/poster4.jpg', '/img/landingPage/poster4.jpg'],
    },
];

const extraVideos: UserVideosType[] = [
    {
        source: 'https://www.youtube.com/embed/JcKq6neGxXk?si=leKqBnkHVezJuNA-',
        desc: 'secO_video5',
        poster: ['/img/landingPage/poster5.jpg', '/img/landingPage/poster5.jpg'],
    },
    {
        source: 'https://www.youtube.com/embed/_zYHtNnuO-A?si=nRQPeg0JqmOFgqKL',
        desc: 'secO_video6',
        poster: ['/img/landingPage/poster6.jpg', '/img/landingPage/poster6.jpg'],
    },
];

export const videoMap: ResType<UserVideosType[]> = {
    us: [...extraVideos, ...usVideoList],
    ca: [...extraVideos, ...usVideoList],
    sa: usVideoList,
    za: usVideoList,
    au: usVideoList,
} as const;

/**
 * @desc 学习更多跳转
 */
type LearnMoreType = {
    readonly title: string;
    readonly desc: string;
    readonly link: string;
};
const usLearnMoreList: LearnMoreType[] = [
    {
        title: 'secO_title1',
        desc: 'secO_desc1',
        link: 'https://www.facebook.com/groups/deltaprolaunch',
    },
    {
        title: 'secO_title2',
        desc: 'secO_desc2',
        link: 'https://us.ecoflow.com/pages/power-outages',
    },
];
const caLearnMoreList: LearnMoreType[] = [
    {
        title: 'secO_title1',
        desc: 'secO_desc1',
        link: 'https://www.facebook.com/groups/deltaprolaunch',
    },
    {
        title: 'secO_title2',
        desc: 'secO_desc2',
        link: 'https://ca.ecoflow.com/pages/power-outages',
    },
];
const mearLearnMoreList: LearnMoreType[] = [
    {
        title: 'secO_title1',
        desc: 'secO_desc1',
        link: 'https://www.facebook.com/groups/deltaprolaunch',
    },
    {
        title: 'secO_title2',
        desc: 'secO_desc2',
        link: 'https://amzn.to/43xh9Wr',
    },
];
const zaLearnMoreList: LearnMoreType[] = [
    {
        title: 'secO_title1',
        desc: 'secO_desc1',
        link: 'https://www.facebook.com/groups/efsouthafrica/',
    },
    {
        title: 'secO_title2',
        desc: 'secO_desc2',
        link: 'https://za.ecoflow.com/pages/load-shedding-solutions',
    },
];
const auLearnMoreList: LearnMoreType[] = [
    {
        title: 'secO_title1',
        desc: 'secO_desc1',
        link: 'https://www.facebook.com/groups/542727324566593',
    },
    {
        title: 'secO_title2',
        desc: 'secO_desc2',
        link: 'https://au.ecoflow.com/pages/disaster',
    },
];
export const learnMoreMap: ResType<LearnMoreType[]> = {
    us: usLearnMoreList,
    ca: caLearnMoreList,
    sa: mearLearnMoreList,
    za: zaLearnMoreList,
    au: auLearnMoreList,
} as const;
